export const commentAPI = {
  getAll: (slug: string | string[], locatedFor: 'post' | 'publication') =>
    `/api/comment/get-comment?${locatedFor}Id=${slug}`,

  create: (slug: string | string[], locatedFor: 'post' | 'publication') =>
    `/api/comment/post-comment?${locatedFor}Id=${slug}`,

  delete: `/api/comment/delete-comment`
};
